const createIDedSelector = (id: string | number, prefix: string) =>
  `${prefix}${String(id)}`;

export const atiraLinkTestIDs = {
  tabs: {
    content: 'e2e_atira-link-create-tabs-content',
    template: 'e2e_atira-link-create-tabs-template',
    design: 'e2e_atira-link-create-tabs-design',
  },
  phone: {
    update: 'e2e_atira-link-create-phone-update-button',
    preview: 'e2e_atira-link-create-phone-preview-button',
  },
  content: {
    linkName: 'e2e_atira-link-create-link-name',
    title: 'e2e_atira-link-create-title',
    bio: 'e2e_atira-link-create-bio',
    phone: {
      label: 'e2e_atira-link-create-phone-label',
      value: 'e2e_atira-link-create-phone-value',
    },
    email: {
      label: 'e2e_atira-link-create-email-label',
      value: 'e2e_atira-link-create-email-value',
    },
    website: {
      label: 'e2e_atira-link-create-website-label',
      value: 'e2e_atira-link-create-website-value',
    },
    map: {
      label: 'e2e_atira-link-create-map-label',
      value: 'e2e_atira-link-create-map-value',
    },
    image: 'e2e_atira-link-create-image',
    imageRemove: 'e2e_atira-link-create-image.remove',
    c: 'e2e_atira-link-create-image.remove',
    customLinks: {
      remove: (id: string | number) =>
        createIDedSelector(
          String(id),
          'e2e_atira-link-create-custom-links-remove-',
        ),
      add: 'e2e_atira-link-create-custom-links-add',
      label: 'e2e_atira-link-create-custom-links-label',
      value: 'e2e_atira-link-create-custom-links-value',
    },
    embed: 'e2e_atira-link-create-embed',
    socialMedia: {
      label: 'e2e_atira-link-create-socials-label',
      value: 'e2e_atira-link-create-socials-value',
      add: 'e2e_atira-link-create-socials-add',
      remove: (id: string | number) =>
        createIDedSelector(String(id), 'e2e_atira-link-create-socials-remove-'),
      dropdown: {
        open: 'e2e_atira-link-create-socials-dropdown-open',
        option: (id: string | number) =>
          createIDedSelector(
            String(id),
            'e2e_atira-link-create-socials-dropdown-',
          ),
      },
    },
  },
  templates: {
    theme: (id: string | number) =>
      createIDedSelector(String(id), 'e2e_atira-link-create-templates-themes-'),
  },
  design: {
    buttons: {
      borderStyle: 'e2e_atira-link-create-design-buttons-border-style',
      borderWidth: 'e2e_atira-link-create-design-buttons-border-width',
      borderRadius: 'e2e_atira-link-create-design-buttons-border-radius',
      borderColor: 'e2e_atira-link-create-design-buttons-border-color',
      backgroundColor: 'e2e_atira-link-create-design-buttons-background-color',
      borderStyleOption: (label: string) =>
        createIDedSelector(
          String(label),
          'e2e_atira-link-create-design-buttons-border-style-option-',
        ),
      borderRadiusOption: (label: string) =>
        createIDedSelector(
          String(label),
          'e2e_atira-link-create-design-buttons-border-radius-option-',
        ),
    },
    image: {
      borderStyle: 'e2e_atira-link-create-design-image-border-style',
      borderWidth: 'e2e_atira-link-create-design-image-border-width',
      borderColor: 'e2e_atira-link-create-design-image-border-color',
      borderRadius: 'e2e_atira-link-create-design-image-border-radius',
      borderStyleOption: (label: string) =>
        createIDedSelector(
          String(label),
          'e2e_atira-link-create-design-image-border-style-option-',
        ),
      borderRadiusOption: (label: string) =>
        createIDedSelector(
          String(label),
          'e2e_atira-link-create-design-image-border-radius-option-',
        ),
    },
    background: {
      options: {
        asColor: 'e2e_atira-link-create-design-background-option-as-color',
        asImage: 'e2e_atira-link-create-design-background-option-as-image',
      },
      color: 'e2e_atira-link-create-design-background-color',
      image: 'e2e_atira-link-create-design-background-image',
      imagePosition: 'e2e_atira-link-create-design-background-image-position',
      imageSize: 'e2e_atira-link-create-design-background-image-size',
      imagePositionOption: (label: string) =>
        createIDedSelector(
          String(label),
          'e2e_atira-link-create-design-background-image-position-option-',
        ),
      imageSizeOption: (label: string) =>
        createIDedSelector(
          String(label),
          'e2e_atira-link-create-design-background-image-size-option-',
        ),
    },
  },
  settings: {
    tabs: {
      general: 'e2e_atira-link-settings-general',
      openGraph: 'e2e_atira-link-settings-open-graph',
      selfHosting: 'e2e_atira-link-settings-self-hosting',
      language: 'e2e_atira-link-settings-language',
      index: 'e2e_atira-link-settings-index',
    },
    brand: {
      switch: 'e2e_atira-link-brand-switch',
      submit: 'e2e_atira-link-brand-submit',
    },
    openGraph: {
      title: 'e2e_atira-link-open-graph-title',
      description: 'e2e_atira-link-open-graph-description',
      image: 'e2e_atira-link-open-graph-image',
      submit: 'e2e_atira-link-open-graph-submit',
    },
    language: {
      dropdownContainer: 'e2e_atira-link-settings-language-dropdown',
      lang: (lang: string) =>
        createIDedSelector(String(lang), 'e2e_atira-link-settings-language-'),
      submit: 'e2e_atira-link-settings-language-submit',
    },
    index: {
      switch: 'e2e_atira-link-settings-index-switch',
      typeDropdownContainer: 'e2e_atira-link-settings-index-type-dropdown',
      type: (type: string) =>
        createIDedSelector(String(type), 'e2e_atira-link-settings-index-type-'),
      categoryDropdownContainer:
        'e2e_atira-link-settings-index-category-dropdown',
      category: (category: string) =>
        createIDedSelector(String(category), 'e2e_atira-link-settings-index-'),
      submit: 'e2e_atira-link-settings-index-submit',
    },
  },
};
